import React, { Fragment } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { loadVideosByShowId } from '../../../api/load-videos-by-show-id';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { MediaTeaser } from '../../../components/Teaser/MediaTeaser/MediaTeaser';
import { MediaTeaserPlaceholder } from '../../../components/Teaser/MediaTeaser/MediaTeaserPlaceholder';
import { queryKeys } from '../../../config/use-query';
import { useAxios } from '../../../hooks/use-axios';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LatestMediaByShow = ({
  show,
  filterMediaUrn
}) => {
  const {
    t
  } = useTranslation();
  const axios = useAxios();
  const {
    data,
    error
  } = useQuery({
    queryKey: [queryKeys.VideosByShowId(show.id), axios],
    queryFn: () => loadVideosByShowId(axios, show.id)
  });
  const filteredVideos = data?.data?.filter(video => video.urn !== filterMediaUrn);
  const showSwimlane = filteredVideos?.length !== 0 && !error;
  return /*#__PURE__*/_jsx(Fragment, {
    children: showSwimlane && /*#__PURE__*/_jsxs(Swimlane, {
      children: [/*#__PURE__*/_jsx(StyledSwimlaneTitle, {
        title: t('videoDetailPage.latestByShow', {
          showName: show.title
        })
      }), /*#__PURE__*/_jsx(Swipeable, {
        buttonPositionFactor: 9 / 16,
        placeholder: /*#__PURE__*/_jsx(MediaTeaserPlaceholder, {}),
        children: filteredVideos?.map((video, index) => /*#__PURE__*/_jsx(MediaTeaser, {
          media: video,
          index: index
        }, video.id))
      })]
    })
  });
};
const StyledSwimlaneTitle = styled(SwimlaneTitle).withConfig({
  displayName: "LatestMediaByShow__StyledSwimlaneTitle",
  componentId: "sc-ls1lv3-0"
})(["", "{display:none;}"], Viewports.for('small'));